import React from 'react';
import ConnectWallet from '../common/ConnectWallet';
import { useWallet } from '../../context/WalletContext';
import { CURRENT_NETWORK } from '../../config/networks';

export default function Navbar() {
  const { wrongNetwork, requestSwitchNetwork, account, switching } = useWallet();

  return (
    <header className="navbar">
      <div className="navbar-brand">
        <span className="logo-dot" />
        Crypto<span className="brand-accent">Pay</span>
      </div>
      <div className="navbar-right">
        {account && (
          wrongNetwork ? (
            <button
              className="network-badge wrong"
              onClick={requestSwitchNetwork}
              disabled={switching}
              title="Click to switch network"
            >
              <span className="net-dot" />
              {switching ? 'Switching...' : 'Wrong Network'}
            </button>
          ) : (
            <span className="network-badge">
              <span className="net-dot" />
              {CURRENT_NETWORK.name}
            </span>
          )
        )}
        <ConnectWallet />
      </div>
    </header>
  );
}
